export const SELECTED_FLEET_CHANGED = 'SELECTED_FLEET_CHANGED'

export function selectedFeetChanged(fleet) {
  return {
    type: SELECTED_FLEET_CHANGED,
    fleet,
  }
}
